import { Mail, Store, UserRound, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import { StepHeading } from "../OnboardingShell";
import { PrimaryButton } from "../ui/buttons";

const CARDS = [
  { key: "account", icon: UserRound },
  { key: "organisation", icon: Store },
  { key: "employees", icon: Users },
  { key: "invite", icon: Mail },
] as const;

interface WelcomeScreenProps {
  onStart: () => void;
}

/** "Kom igång med er organisation på 10 minuter": what the four parts are and how long each takes. */
export function WelcomeScreen({ onStart }: WelcomeScreenProps) {
  const { t } = useTranslation("onboarding");
  return (
    <div data-testid="onboarding-welcome">
      <StepHeading title={t("welcome.title")} lead={t("welcome.lead")} />
      <p className="text-[15px] leading-relaxed text-g-ink-600">{t("welcome.body")}</p>
      <ul className="mt-6 grid gap-3 sm:grid-cols-2">
        {CARDS.map(({ key, icon: Icon }) => (
          <li
            key={key}
            className="flex items-start gap-3 rounded-g-lg border border-g-line bg-g-bg-card p-4"
          >
            <span
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-g-md bg-g-primary-tint text-g-primary"
              aria-hidden="true"
            >
              <Icon className="h-5 w-5" />
            </span>
            <span className="flex min-w-0 flex-1 flex-col gap-0.5">
              <span className="flex items-center justify-between gap-2">
                <span className="text-[15px] font-bold text-g-ink-900">
                  {t(`welcome.cards.${key}.title`)}
                </span>
                <span className="rounded-g-pill bg-g-bg-track px-2 py-0.5 text-[11px] font-bold text-g-ink-500">
                  {t(`welcome.cards.${key}.time`)}
                </span>
              </span>
              <span className="text-[13.5px] text-g-ink-500">{t(`welcome.cards.${key}.desc`)}</span>
            </span>
          </li>
        ))}
      </ul>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-[13px] text-g-ink-500">{t("welcome.note")}</p>
        <PrimaryButton onClick={onStart} className="sm:min-w-40">
          {t("welcome.start")}
        </PrimaryButton>
      </div>
    </div>
  );
}
